import React, { useState, useRef } from "react";
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { addEtablissement } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IEtabPayload, IEtabState } from "./interface";


interface IAddProps {
  etabState: IEtabState;
  setEtabState: (x: IEtabState) => void;
  setSelectedPhoto: (x: any) => void;
  image: string;
  setImage: (x: string) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    etabState,
    setEtabState,
    setSelectedPhoto,
    image,
    setImage
  } = props


  //hooks
  const selectPhoto: any = useRef(null);

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEtabState({ ...etabState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={3} xs={12} sm={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <div style={{ width: "15vw", height: "30vh", border: "1px solid gray" }}>
                <img
                  src={image}
                  style={{ width: "15vw", height: "30vh" }}
                />
              </div>
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger le logo">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger le logo
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                name="libEtab"
                label="Libellé établissement"
                value={etabState.libEtab}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const initialState = {
  libEtab: ""
}

const DialogAdd = () => {


  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [etabState, setEtabState] = useState<IEtabState>(initialState)
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})
  const [image, setImage] = useState<string>("");

  //Fermer la boite de dialog d'ajout d'établissement
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout d'établissement
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer un établissement
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      //Obtenir l'image qui decrit l'actualité en base 64
      const logoEtabEnbase64 = selectedPhoto ? await convertToBase64(selectedPhoto) : "";
      //Constituer le payload final
      const apiPayload: IEtabPayload = {
        ...etabState,
        logoEtabEnbase64: logoEtabEnbase64,
      }
      // Envoi de la requête 
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/ajouteretablissement",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(addEtablissement(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setEtabState(initialState)
        setImage("")
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:252 ~ handleSave ~ error:", error)
      setAddLoading(false)
    }
  }
  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          etabState={etabState}
          setEtabState={setEtabState}
          setSelectedPhoto={setSelectedPhoto}
          image={image}
          setImage={setImage}
        />}
      actionFunc={handleSave}
      title="Etab"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



